import injectSheet from 'react-jss'
import classNames from 'classnames'
import { useSelector } from 'react-redux'
import BtnLink from '@/components/BtnLink'
import ParallaxImg from '@/components/ParallaxImg'
import DelayLink from '@/components/DelayLink'
import { removeBr } from '@/utils/strings'
import style from './style'

const FeaturedCards = ({
  className,
  classes,
  items,
  label,
  link,
  pretitle,
  root,
  text,
  title,
}) => {
  const strings = useSelector((state) => state.language.string)

  return (
    <div
      className={classNames({
        [classes.root]: true,
        [classes.rootDark]: root === 'dark',
        [classes.rootLight]: root === 'light',
        [classes.rootOrange]: root === 'orange',
        [className]: className,
      })}
    >
      <div className={classes.wrapper}>
        <div className={classes.container}>
          {(title && text) && (
            <div className={classes.textBlock}>
              {pretitle && <div className={classes.pretitle}>{pretitle}</div>}
              {title && (
                <div
                  className={classes.title}
                  dangerouslySetInnerHTML={{ __html: title }}
                />
              )}
              {text && (
                <div
                  className={classes.text}
                  dangerouslySetInnerHTML={{ __html: text }}
                />
              )}
              {link && (
                <BtnLink
                  link={link}
                  label={label || strings.viewall_label}
                  theme={root === 'dark' || root === 'light' ? 'orange' : 'light'}
                />
              )}
            </div>
          )}
          <div
            className={classNames({
              [classes.cardList]: true,
              [classes.cardListFull]: !title && !text,
            })}
          >
            <div className={classes.cardListTrack}>
              {items.map((item) => {
                if (item.link) {
                  return (
                    <DelayLink
                      to={item.link}
                      className={classes.card}
                      key={item.id}
                    >
                      <div className={classes.cardImage}>
                        <ParallaxImg
                          img={item.img}
                          title={removeBr(item.title)}
                        />
                      </div>
                      <div className={classes.cardInfo}>
                        {item.cat && (
                        <p className={classes.cardCategory}>{item.cat}</p>
                        )}
                        <h3 className={classes.cardTitle}>{removeBr(item.title)}</h3>
                        <div className={classes.cardText}>
                          {item.text}
                        </div>
                      </div>
                    </DelayLink>
                  )
                }
                return (
                  <div
                    className={classes.card}
                    key={item.id}
                  >
                    <div className={classes.cardImage}>
                      <ParallaxImg
                        img={item.img}
                        title={removeBr(item.title)}
                      />
                    </div>
                    <div className={classes.cardInfo}>
                      {item.cat && (
                        <p className={classes.cardCategory}>{item.cat}</p>
                      )}
                      <h3 className={classes.cardTitle}>{removeBr(item.title)}</h3>
                      <div className={classes.cardText}>
                        {item.text}
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

FeaturedCards.defaultProps = {
  root: 'light',
}

export default injectSheet(style)(FeaturedCards)
